/**
 * 체결 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class ExecutionService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 주문 체결 합계 조회
     * 거래 > 거래내역 > 주문체결 조회시 사용한다.
     * @param request - 주문 체결 합계 조회 요청 데이터
     * @returns 주문 체결 합계 조회 결과
     */
    getOrderExecutionSummary(request) {
        return this.axios.get(`/main/v1/execution/summary`, {
            params: request,
        });
    }
    /**
     * 거부사유 조회
     * 주문체결 내역에서 거부(4)에 대한 사유 조회시 사용한다.
     * @param request - 거부사유 조회 요청 데이터
     * @returns 거부사유 조회 결과
     */
    getOrderRejectHistory(request) {
        return this.axios.get(`/main/v1/execution/reject/history`, {
            params: request,
        });
    }
    /**
     * 미체결 내역 조회
     * 미체결 내역 탭 조회시 사용한다.
     * @param request - 미체결 내역 조회 요청 데이터
     * @returns 미체결 내역 조회 결과
     */
    getPendingOrderHistory(request) {
        return this.axios.get(`/main/v1/execution/pending/history`, {
            params: request,
        });
    }
    /**
     * 주문 체결 내역 조회
     * 거래 > 거래내역 > 주문체결 조회시 사용한다.
     * @param request - 주문 체결 내역 조회 요청 데이터
     * @returns 주문 체결 내역 조회 결과
     */
    getOrderExecutionHistory(request) {
        return this.axios.get(`/main/v1/execution/history`, {
            params: request,
        });
    }
}
//# sourceMappingURL=execution.service.js.map